import { useNavigate } from "react-router-dom"; 
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";

const SmsCampaign = () => {
  const navigate = useNavigate(); 
  const defaultColumns: any = [
    {
      header: "Campaign",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Status",
      accessorKey: "is_draft",
      cell: ({ getValue }: any) => <p>{getValue() ? "Draft" : "Submitted"}</p>,
    },
    {
      header: "Date",
      accessorKey: "schedule_time",
      cell: NACell,
    },
    {
      header: "From",
      accessorKey: "sender",
      cell: NACell,
    },
    {
      header: "Recipients",
      accessorKey: "recipient_list",
      cell: ({ getValue }: any) => {
        const conatcts = getValue()?.split(",") || [];
        const visibleCount = 2;
        const visibleContacts = conatcts.slice(0, visibleCount);
        const tooltipContent = conatcts.join(", ");
        return (
          <div className="flex gap-1 flex-wrap" title={tooltipContent}>
            {visibleContacts.map((contact: string, index: number) => (
              <div key={index} className={tw` `}>
                {contact}
              </div>
            ))}
            {conatcts?.length > 2 ? "..." : ""}
          </div>
        );
      },
    },

  ];

  return (
    <DataTable
      url={APIS.SMS_CAMPAIGN}
      queryKey={"sms-campaign"}
      columns={defaultColumns}
      addNewPagePath={"/email-sms-marketing/sms-campaign/create"}
      tableName={"SmS campaign"}
      onRowClick={(row: any) => {
        const id = row?.original?.id;
        if (id) {
          navigate(`/email-sms-marketing/sms-campaign/edit/${id}`);
        }
      }}
    />
  );
};

export default SmsCampaign;